import Title from "ant-design-vue/es/typography/Title";

export default {
  Export: "Export",
  Print: "Print",
  Save: "Save",
  Cancel: "Cancel",
  Description: "Description",
  Dashboard: "Dashboard",
  Event: "Event",
  Product: "Product",
  Supplier: "Supplier",
  Customer: "Customer",
  SaleEmployee: "Sales Employee",
  AddItem: "Add Item",
  DiscountRate: "Discount rate",
  Item: "Item",
  Category: "Category",
  Order: "Order",
  HelpSupport: "Help & Support",
  Setting: "Setting",
  AboutMe: "About Us",
  Shipper: "Shipper",
  Search: "Search",
  AddProduct: "Add Product",
  AddSupplier: "Add Supplier",
  AddOrder: "Add Order",
  AddCustomer: "Add Customer",
  AddCategory: "Add Category",
  AddEmployee: "Add Employee",
  AddShipper: "Add Shipper",
  AddEvent: "Add Event",
  EditProduct: "Edit Product",
  EditSupplier: "Edit Supplier",
  EditCustomer: "Edit Customer",
  EditOrder: "Edit Order",
  EditCategory: "Edit Category",
  EditEmployee: "Edit Employee",
  EditEvent: "Edit Event",
  EditShipper: "Edit Shipper",
  EditItem: "Edit Item",
  EditUser: "Edit User",
  ProductManage: "Product Management System",
  UserName: "Username",
  Password: "Password",
  Login: "Login",
  ForgotPassword: "Forgot Password",
  Logout: "Logout",
  HasAccount: "Already have an account?",
  Register: "Register",
  userNameInvalid: "Username cannot be empty",
  passwordInvalid: "Password cannot be empty",
  Sale: "Sale",
  Active: "Active",
  Inactive: "Inactive",
  HotLineZalo: "Hotline (Zalo): 0946210891",
  Add: "Add",
  AddMore: "Add More",
  MessageResponse: "Error message",
  TestekTitleDashboard: "TESTEK - REAL TESTING",
  ViewDetail: "View Detail",
  LoginSuccess: "Login Successful",
  LoginFail: "Login Failed",
  FeatureUnderDevelop: "Feature under development",
  Vietnamese: "Vietnamese",
  English: "English",
  Language: "Language",
  TitleProductId: "Product ID",
  TitleCategoryId: "Category ID",
  TitleSupplierId: "Supplier ID",
  TitleSaleEmployeeId: "Sales Employee ID",
  TitleCustomerId: "Customer ID",
  TitleShipperId: "Shipper ID",
  TitleOrderId: "Order ID",
  TitleEventId: "Event ID",
  TitleItemId: "Item ID",
  TitleDetailInfo: "Detail Information",
  TitleUserId: "User ID",
  TitleGroupId: "User Group ID",
  Close: "Close",
  Save: "Save",
  Status: "Status",
  Delete: "Delete",
  Edit: "Edit",
  AddGroup: "Add to Group",
  AddPolicy: "Add Policy",
  CategoryInfo: {
    CategoryName: "Category Name",
    CategoryDescription: "Category Description",
    Status: "Status",
  },

  EmployeeInfo: {
    Name: "Name",
    PhoneNumber: "Phone Number",
    Code: "Employee Code",
    DOB: "Date of Birth",
    Avatar: "Avatar",
    Note: "Note",
    Status: "Status",
    Group: "Group",
    Email: "Email",
  },

  CustomerInfo: {
    Name: "Name",
    PhoneNumber: "Phone Number",
    Email: "Email",
    Country: "Country",
    City: "City",
    Address: "Address",
    PostalCode: "Postal Code",
    Status: "Status",
    Type: "Type",
    Guest: "Is Guest",
  },

  SupplierInfo: {
    Address: "Address",
    City: "City",
    ContactName: "Contact Name",
    Country: "Country",
    Name: "Name",
    PhoneNumber: "Phone Number",
    PostalCode: "Postal Code",
  },

  OrderInfo: {
    ShippingAddress: "Shipping Address",
    ShippingPhone: "Shipping Phone",
    InvoiceAddress: "Invoice Address",
    Quantity: "Quantity",
    Total: "Total",
    Status: "Status",
  },

  UserInfo: {
    Code: "User Code",
    Name: "User Name",
    DoB: "Date of Birth",
    Group: "Group",
    Other: "Other Information",
    Action: "Action",
    User: "User",
    Roles: "Roles",
    Email: "Email",
    PhoneNumber: "Phone Number",
    IdentityNumber: "Identity Number",
    AccountState: "Account Status",
  },

  GroupInfo: {
    Code: "Group Code",
    Name: "Group Name",
    Other: "Other Information",
    Action: "Action",
    Description: "Description",
    Status: "Status",
    ResourceName: "Resource Name",
    ResourceCode: "Resource Code",
  },

  EditSupplier: "Edit Supplier",
  AddCategorySuccess: "Add Category Successful",
  AddCategoryFail: "Add Category Failed",
  AddEmployeeSuccess: "Add Employee Successful",
  AddEmployeeFail: "Add Employee Failed",
  AddCustomerSuccess: "Add Customer Successful",
  AddCustomerFail: "Add Customer Failed",
  AddSupplierSuccess: "Add Supplier Successful",
  AddSupplierFail: "Add Supplier Failed",
  AddProductSuccess: "Add Product Successful",
  AddProductFail: "Add Product Failed",
  AddOrderSuccess: "Add Order Successful",
  AddOrderFail: "Add Order Failed",
  AddShipperSuccess: "Add Shipper Successful",
  AddShipperFail: "Add Shipper Failed",
  AddEventSuccess: "Add Event Successful",
  AddEventFail: "Add Event Failed",
  AddItemSuccess: "Add Item Successful",
  AddItemFail: "Add Item Failed",

  EditCategorySuccess: "Edit Category Successful",
  EditCategoryFail: "Edit Category Failed",
  EditEmployeeSuccess: "Edit Employee Successful",
  EditEmployeeFail: "Edit Employee Failed",
  EditCustomerSuccess: "Edit Customer Successful",
  EditCustomerFail: "Edit Customer Failed",
  EditSupplierSuccess: "Edit Supplier Successful",
  EditSupplierFail: "Edit Supplier Failed",
  EditProductSuccess: "Edit Product Successful",
  EditProductFail: "Edit Product Failed",
  EditOrderSuccess: "Edit Order Successful",
  EditOrderFail: "Edit Order Failed",
  EditShipperSuccess: "Edit Shipper Successful",
  EditShipperFail: "Edit Shipper Failed",
  EditEventSuccess: "Edit Event Successful",
  EditEventFail: "Edit Event Failed",
  EditItemSuccess: "Edit Item Successful",
  EditItemFail: "Edit Item Failed",

  DeleteProductSuccess: "Delete Product Successful",
  DeleteProductFail: "Delete Product Failed",
  DeleteCategorySuccess: "Delete Category Successful",
  DeleteCategoryFail: "Delete Category Failed",
  DeleteEmployeeSuccess: "Delete Employee Successful",
  DeleteEmployeeFail: "Delete Employee Failed",
  DeleteCustomerSuccess: "Delete Customer Successful",
  DeleteCustomerFail: "Delete Customer Failed",
  DeleteSupplierSuccess: "Delete Supplier Successful",
  DeleteSupplierFail: "Delete Supplier Failed",
  DeleteOrderSuccess: "Delete Order Successful",
  DeleteOrderFail: "Delete Order Failed",
  DeleteShipperSuccess: "Delete Shipper Successful",
  DeleteShipperFail: "Delete Shipper Failed",
  DeleteEventSuccess: "Delete Event Successful",
  DeleteEventFail: "Delete Event Failed",
  DeleteItemSuccess: "Delete Item Successful",
  DeleteItemFail: "Delete Item Failed",
  DeleteUserSuccess: "Delete User Successful",
  DeleteUserFail: "Delete User Failed",
  DeleteGroupSuccess: "Delete User Group Successful",
  DeleteGroupFail: "Delete User Group Failed",
  TotalAmount: "Total Amount",
  AddRow: "Add Row",
  Confirm: "Confirm",
  Total: "Total",
  Quantity: "Quantity",
  Price: "Price",
  SaveRow: "Save Row",
  DeleteRow: "Delete Row",
  EditRow: "Edit Row",
  OverQuantity: "Over Quantity",
  MaxRowItems: "Maximum Row Items",
  MinRowItems: "Cannot delete the first row",
  Warning: "Warning",
  SaveRowBeforeSubmit: "Please save the row before performing this action",
  NotRowSave: "Please add at least one row before saving",
  ChangeQuantityOverBeforeSubmit:
    "The quantity on the row exceeds the available quantity",
  DeleteProductConfirm: `Are you sure you want to delete the product {name}?`,
  DeleteCategoryConfirm: `Are you sure you want to delete the category {name}?`,
  DeleteEmployeeConfirm: `Are you sure you want to delete the employee {name}?`,
  DeleteCustomerConfirm: `Are you sure you want to delete the customer {name}?`,
  DeleteSupplierConfirm: `Are you sure you want to delete the supplier {name}?`,
  DeleteOrderConfirm: `Are you sure you want to delete the order {name}?`,
  DeleteShipperConfirm: `Are you sure you want to delete the shipper {name}?`,
  DeleteUserConfirm: "Are you sure you want to delete the user {name}?",
  DeleteGroupConfirm: "Are you sure you want to delete the user group {name}?",
  ReloadData: "Reload Data",

  QuantityRowOver: "The quantity on the row exceeds the available quantity",
  AreYouSureDelete: "Are you sure you want to delete?",
  Yes: "Yes",
  No: "No",
  User: "User",
  Action: "Action",

  SignInAs: "Sign in as",
  Account1: "Admin",
  Account2: "User",
  Account3: "Guest",
  InputForSearch: "Enter to search",
  Group: "Group",
  AddUser: "Add user",
  AddToGroup: "Add to group",
  SelectGroup: "Select group",
  OrderStatus: "Order Status",
  ClearFilter: "Clear Filter",
  AddGroupFail: "Add group failed",
  AddGroupSuccess: "Add group successful",
};
